import Crud from '../views/TipoAvaliacaoClinica/Crud'
import Entity from '../views/TipoAvaliacaoClinica/Add'

let routes = {
    path: '/tipo_avaliacao_clinica',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_avaliacao_clinica/add',
            name: 'NovoTransporte',
            component: Entity
        },
        {
            path: '/tipo_avaliacao_clinica/edit/:id?',
            name: 'EditarTransporte',
            component: Entity
        },
        {
            path: '/tipo_avaliacao_clinica',
            name: 'list-avaliacao-clinica',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Avaliações Clinicas',
                breadcrumb: [
                    {
                        text: 'Avaliações Clinicas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
